import { AudienceFragment, MessagingCampaignDetailsFragment } from '@occc/graphql';
import { parseDate } from '@occc-app/lib/date';
import { getFormValues } from '@occc/ui-notifications';

import { MessagingCampaignConfigureFormValues } from '../components/configure-form/configure-form.types';
import { MessagingCampaignTargetFormInitialValues } from '../components/target-form/target-form.types';
import { MessagingCampaignScheduleFormInitialValues } from '../components/schedule-form/schedule-form.types';

type ConvertMessagingCampaignToInitialValuesParams = {
  campaign?: MessagingCampaignDetailsFragment | null;
  audience?: AudienceFragment;
};

type ConvertMessagingCampaignToInitialValuesReturns = {
  configure: Partial<MessagingCampaignConfigureFormValues>;
  target: MessagingCampaignTargetFormInitialValues;
  schedule: MessagingCampaignScheduleFormInitialValues;
};

export const convertMessagingCampaignToInitialValues = ({
  campaign,
  audience,
}: ConvertMessagingCampaignToInitialValuesParams): ConvertMessagingCampaignToInitialValuesReturns => {
  const configure: Partial<MessagingCampaignConfigureFormValues> = {
    ...getFormValues(campaign?.channelsConfig),
    title: campaign?.title ?? '',
    description: campaign?.description ?? undefined,
  };

  const target: MessagingCampaignTargetFormInitialValues = {
    // An empty uuid represents "Universal" (no sub brand).
    subBrand: { uuid: campaign?.subBrandUuid ?? '' },
    ...(audience && {
      inAudience: {
        id: audience.uuid,
        audience: {
          uuid: audience.uuid,
          membershipCount: audience.membershipCount,
          name: audience.name,
          status: audience.status,
          hasBeenBackFilled: audience.hasBeenBackFilled,
          targetingAttributes: audience.targetingAttributes,
        },
      },
    }),
  };

  const publishAt = parseDate(campaign?.scheduleAt || null);

  const schedule: MessagingCampaignScheduleFormInitialValues = campaign?.scheduleAt
    ? {
        publishAtDate: publishAt,
        publishAtTime: publishAt,
      }
    : {};

  return { configure, target, schedule };
};
